// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 747) return "static/css/747.0faf11e81.chunk.css";
	// return url for filenames based on template
	return undefined;
};